export const PendingSubmission = 'PendingSubmission';
export const Successful = 'Successful';
export const Unsuccessful = 'Unsuccessful';

export type FormStatus = typeof PendingSubmission | typeof Successful | typeof Unsuccessful;
